import { Injectable, inject } from "@angular/core";
import type { AdminPurchaseDetailDTO, PurchaseDTO } from "@magpie/types";
import { TrpcService } from "./trpc.service";
import { AnalyticsService } from "./analytics.service";

@Injectable({
	providedIn: "root",
})
export class PurchaseService {
	private readonly trpc = inject(TrpcService);
	private readonly analytics = inject(AnalyticsService);

	async purchaseDash(dashId: string, quantity = 1): Promise<PurchaseDTO> {
		this.analytics.track("purchase_initiated", {
			dash_id: dashId,
			quantity,
			currency: "USD",
		});
		try {
			const result = await this.trpc.client.purchase.create.mutate({
				dashId,
				quantity,
				currency: "USD",
			});
			this.analytics.track("purchase_succeeded", {
				dash_id: dashId,
				purchase_id: result.id,
				quantity,
				currency: result.currency,
				total_amount: result.totalAmount,
			});
			return result;
		} catch (err) {
			this.analytics.track("purchase_failed", {
				dash_id: dashId,
				quantity,
				error: err instanceof Error ? err.message : String(err),
			});
			throw err;
		}
	}

	async getPurchases(): Promise<PurchaseDTO[]> {
		return this.trpc.client.purchase.list.query();
	}

	async getPurchaseById(purchaseId: string): Promise<PurchaseDTO> {
		return this.trpc.client.purchase.getById.query({ id: purchaseId });
	}

	async deletePurchase(purchaseId: string, reason = "test"): Promise<void> {
		await this.trpc.client.purchase.delete.mutate({ id: purchaseId, reason });
	}

	async getAllPurchasesAdmin(): Promise<AdminPurchaseDetailDTO[]> {
		const result = await this.trpc.client.purchaseAdmin.listAll.query();
		return result.items;
	}

	async deletePurchaseAdmin(
		purchaseId: string,
		reason = "admin deletion",
	): Promise<void> {
		await this.trpc.client.purchaseAdmin.delete.mutate({
			id: purchaseId,
			reason,
		});
	}
}
